import { mapActions, mapGetters } from 'vuex'
import commonHelper from '~/global_helper/helpers.js'

export default {
	data() {
		return {
			stanPaymentLoading: false,
			stanPaymentPopup: undefined,
		}
	},
	computed: {
		...mapGetters('Auth', ['user']),
		...mapGetters('SiteSettingsStore', ['isStripeConnected', 'isStripeMarketplaceConnected', 'isStanPaymentConnected', 'isAdyenConnected']),
	},

	methods: {
		...mapActions('SiteSettingsStore', ['fetchStripeConnected', 'fetchIntegrations', 'fetchStanPayment']),
		connectStripe(nextAction = undefined, popupWindowClosedDelay = false) {
			const authPopupWindow = commonHelper.createCenteredPopupWin(
				'/integration-authorization?connect=stripe',
				'Connect Stripe Integration',
				500,
				800
			)
			if (popupWindowClosedDelay) localStorage.setItem('stripe-connect-started', 'True')
			if (authPopupWindow) {
				const timer = setInterval(() => {
					if (authPopupWindow.closed || (popupWindowClosedDelay && localStorage.getItem('stripe-connect-started') === 'False')) {
						this.fetchStripeConnected().then(() => {
							if (this.isStripeConnected) {
								this.$stanAnalytics('stripe-connected', {
									meta: { user_id: this.user.user_id, username: this.user.username },
								})
								this.connectStripeCompleted(nextAction)
							}
							localStorage.setItem('stripe-connect-started', 'False')
						})
						clearInterval(timer)
					}
				}, 300)
			}
			return authPopupWindow
		},
		connectStripeMarketplace(popupWindowClosedDelay = false) {
			const authPopupWindow = commonHelper.createCenteredPopupWin(
				'/integration-authorization?connect=stripe/marketplace',
				'Connect Stripe Integration',
				500,
				800
			)
			if (popupWindowClosedDelay) localStorage.setItem('stripe-connect-started', 'True')

			if (authPopupWindow) {
				this.stanPaymentPopup = authPopupWindow
				window.addEventListener('message', this.handleMessage)
				const timer = setInterval(() => {
					if (authPopupWindow.closed || (popupWindowClosedDelay && localStorage.getItem('stripe-connect-started') === 'False')) {
						this.fetchIntegrations().then(() => {
							if (this.isStripeMarketplaceConnected) {
								this.$stanAnalytics('stripe-marketplace-connected', {
									meta: { user_id: this.user.user_id, username: this.user.username },
								})
							}
						})
						clearInterval(timer)
					}
				}, 300)
			}
			return authPopupWindow
		},
		connectStripeStandard(nextAction = undefined, popupWindowClosedDelay = false) {
			const authPopupWindow = commonHelper.createCenteredPopupWin(
				'/integration-authorization?connect=stripe/standard',
				'Connect Stripe Integration',
				500,
				800
			)
			if (popupWindowClosedDelay) localStorage.setItem('stripe-connect-started', 'True')

			if (authPopupWindow) {
				this.stanPaymentPopup = authPopupWindow
				window.addEventListener('message', this.handleMessage)
				const timer = setInterval(() => {
					if (authPopupWindow.closed || (popupWindowClosedDelay && localStorage.getItem('stripe-connect-started') === 'False')) {
						this.fetchIntegrations().then(() => {
							if (this.isStripeConnected) {
								if (this.$cookies.get('checklist-stripe-standard')) {
									this.$axios.put(`/v1/experiments/variant-assignment`, {
										name: 'standard_stripe_accounts',
										variant: 1,
									})
								}
								this.$stanAnalytics('stripe-standard-connected', {
									meta: { user_id: this.user.user_id, username: this.user.username },
								})
								this.connectStripeCompleted(nextAction)
							}
						})
						clearInterval(timer)
					}
				}, 300)
			}
			return authPopupWindow
		},
		connectAdyen(popupWindowClosedDelay = false) {
			const authPopupWindow = commonHelper.createCenteredPopupWin(
				'/integration-authorization?connect=adyen',
				'Connect Adyen Integration',
				500,
				800
			)
			if (popupWindowClosedDelay) localStorage.setItem('adyen-connect-started', 'True')
			if (authPopupWindow) {
				const timer = setInterval(() => {
					if (authPopupWindow.closed || (popupWindowClosedDelay && localStorage.getItem('adyen-connect-started') === 'False')) {
						this.fetchIntegrations().then(() => {
							if (this.isAdyenConnected) {
								this.$stanAnalytics('adyen-connected', {
									meta: { user_id: this.user.user_id, username: this.user.username },
								})
							}
							localStorage.setItem('adyen-connect-started', 'False')
						})
						clearInterval(timer)
					}
				}, 300)
			}
			return authPopupWindow
		},
		connectStripeCompleted(nextAction) {
			if (nextAction === 'navigate-to-dashboard') {
				this.$cookies.set('hide-stripe-card', true, {
					path: '/',
					secure: true,
					sameSite: 'strict',
				})
				this.$stanNotify({
					type: 'success', // can be 'info', 'warning', 'success', 'error'
					title: this.$t('Stripe Connected!'),
					text: this.$t("You're all set to continue receiving payments securely with Stripe."),
					duration: 5000,
				})
				this.$router.push({ name: 'dashboard' })
			}
		},
		connectStanPayment() {
			this.stanPaymentLoading = true
			this.$axios
				.post('v1/integrations/stan-payment/generate-link')
				.then(response => {
					if (response.data.onboarding_link) {
						this.stanPaymentPopup = this.connectStanPaymentPopup(response.data.onboarding_link)
						window.addEventListener('message', this.handleMessage)
					}
				})
				.catch(err => {
					// eslint-disable-next-line no-console
					console.log(err)
				})
				.finally(() => {
					this.stanPaymentLoading = false
				})
		},
		handleMessage(event) {
			if (event.data === 'submitSuccess') {
				if (this.stanPaymentPopup) {
					this.stanPaymentPopup.close()
					window.removeEventListener('message', this.handleMessage)
					this.fetchIntegrations()
				}
			}
		},
		connectStanPaymentPopup(onboardingLink, popupWindowClosedDelay = false) {
			const authPopupWindow = commonHelper.createCenteredPopupWin(onboardingLink, 'Connect Stan Payment', 500, 800)
			if (authPopupWindow) {
				const timer = setInterval(() => {
					if (authPopupWindow.closed || (popupWindowClosedDelay && localStorage.getItem('stripe-connect-started') === 'False')) {
						// this.fetchStripeConnected()
						this.fetchStanPayment()
						clearInterval(timer)
					}
				}, 300)
			}
			return authPopupWindow
		},
	},
}
